import { DASHBOARD_FILTER_IDS } from './filterRegistry';

const {
    REGISTERED_AT,
    AREA_NAME,
    SHOP_NAME,
    AGENT_FULLNAME,
    BUYER_AGENT_FULLNAME,
    SELLER_AGENT_FULLNAME,
    SOURCE_NAME,
    LEAD_SOURCE_NAME,
    SOURCE_AUTOCOMPLETE_NAME,
    STATUS_NEW_EXISTING,
    PRODUCT_LEAD,
    PRODUCT_PROPOSAL,
    ACTION_LISTING,
    YEAR_STATIC,
    LEGAL_ENTITY_STATIC,
} = DASHBOARD_FILTER_IDS;

export const FILTER_SET_SUMMARY = [
    REGISTERED_AT,
    AREA_NAME,
    SHOP_NAME,
    LEAD_SOURCE_NAME,
    PRODUCT_LEAD,
];

export const FILTER_SET_LEAD = [
    REGISTERED_AT,
    AREA_NAME,
    SHOP_NAME,
    //AGENT_FULLNAME,
    LEAD_SOURCE_NAME,
    STATUS_NEW_EXISTING,
    PRODUCT_LEAD,
];

export const FILTER_SET_ADVERTISING_COST = [...FILTER_SET_LEAD];

export const FILTER_SET_LISTING = [
    REGISTERED_AT,
    AREA_NAME,
    SHOP_NAME,
    AGENT_FULLNAME,
    ACTION_LISTING,
];

export const FILTER_SET_PROPOSAL = [
    REGISTERED_AT,
    AREA_NAME,
    SHOP_NAME,
    BUYER_AGENT_FULLNAME,
    SELLER_AGENT_FULLNAME,
    LEAD_SOURCE_NAME,
    //SOURCE_AUTOCOMPLETE_NAME,
    //STATUS_NEW_EXISTING,
    PRODUCT_PROPOSAL,
];

export const FILTER_SET_BUDGET = [
    YEAR_STATIC,
    LEGAL_ENTITY_STATIC,
    AREA_NAME,
    SOURCE_NAME,
];
